import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'

// import other components within the same project here

import Localization from "../../Localization.jsx"
import Helper from "../../Helper.jsx"

import {
  grey,
} from '@material-ui/core/colors'

import UserList from "../../views/storage/UserList.jsx"
import SchoolList from "../../views/storage/SchoolList.jsx"
import KLAList from "../../views/locale/KLAList.jsx"

import {
  Icon,
  Button,
  IconButton,
  TextField,
  Tooltip,
  LinearProgress,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from '@material-ui/core';

const styles = {
  localeFilter: {
    display:'inline-block',
    verticalAlign:'middle',
    padding: '0 8px',
  },
};

class LocaleViewerBar extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      searchText: "",
      fileSize: 0,
      fileSizePercentage: 0,
      userOption: 0,
      userList: [],
      mySchoolId: this.props.root.getMySchoolId(),
      filterKLA: this.props.parent.state.filterKLA,
      localeSort: 0,
      localeSortField: "id",
      localeSortOrder: "DESC",
    };
    autoBind(this);

    this.getTotalLocaleSizeBySchoolId(this.props.root.getMySchoolId());
    this.getUserListBySchoolId(this.props.root.getMySchoolId());
  }

  createLocale() {
    if (this.props.root.state.canUpload) {
      this.props.parent.refs.createLocaleDialog.setState({ open: true });
    }
    else {
      this.props.root.showStorageQuotaDialog(this.props.root.emptyFunction);
    }
  }

  refreshLocale() {
    this.props.parent.refreshLocaleList();
  }

  searchTextChanged(e) {
    this.setState({ searchText: e.target.value });
    this.state.searchText = e.target.value;
  }

  handleSearchClicked() {
    let localeName = this.state.searchText.trim();
    this.props.parent.filterLocaleByLocaleName(localeName);
  }

  handleSearchEnterPressed(e) {
    if (e.key === "Enter") {
      this.handleSearchClicked();
    }
  }

  clearFilter() {
    this.setState({
      searchText: "",
      filterKLA: 0,
    });
    this.state.searchText = "";
    this.state.filterKLA = 0;

    if (this.refs.schoolList != null) {
      this.refs.schoolList.onInputChanged(null, "", "");
    }

    if (this.props.parent.onClearFilter) {
      this.props.parent.onClearFilter();
    }
  }

  handleClearClicked() {
    this.clearFilter();

    this.refreshLocale();
  }

  getTotalLocaleSizeBySchoolId(schoolId) {
    let requestObj = { school_id: schoolId };
    this.props.root.refs.API.request("get_total_locale_size_by_school_id", requestObj, this.getTotalLocaleSizeOK, this.getTotalLocaleSizeFailed);
  }

  getTotalLocaleSizeOK(res) {
    let resultSize = res.body['result'];
    let usageSize = (resultSize / (1024 * 1024 * 1024)).toFixed(2);
    let usagePercentage = usageSize / 20.0 * 100;
    /*if (usagePercentage >= 100.0) {
      this.props.root.disableUpload();
    }
    else {
      this.props.root.enableUpload();
    }*/
    this.props.root.enableUpload();

    this.setState({
      fileSize: resultSize,
      fileSizePercentage: usagePercentage,
    });
    this.state.fileSize = resultSize;
    this.state.fileSizePercentage = usagePercentage;
  }

  getTotalLocaleSizeFailed(err) {
    console.log("get total locale size failed");
  }

  getUserListBySchoolId(schoolId) {
    var requestObj = {school_id: schoolId};
    this.props.root.refs.API.request("get_user_data_by_school_id", requestObj, this.getUserListOK, this.getUserListFailed);
  }

  getUserListOK(res) {
    this.setState({userList: res.body['result']});
    this.state.userList = res.body['result'];
    this.setDefaultUserOption(this.props.root.getMyUserId());
  }

  getUserListFailed(err) {
    console.log("getUserListFailed");
  }

  setDefaultUserOption(userId) {
    let option = 0;

    for (var i = 0; i < this.state.userList.length; i++) {
      if (this.state.userList[i]['id'] == userId) {
        option = i;
      }
    }

    this.setState({ userOption: option });
    this.state.userOption = option;

    /*
    // Admin
    if (userList.length > 0) {
      var userId = userList[this.state.userOption]['id'];
      this.props.root.getUserDataById(userId);

      this.props.parent.filterLocaleBySchoolAndUserId(this.state.mySchoolId, userId);
    }
    else {
      this.props.parent.filterLocaleBySchoolId(this.state.mySchoolId);
    }
    */
  }

  userOptionChanged(e) {
    let index = e.target.value;
    this.setState({ userOption: index });
    this.state.userOption = index;

    this.clearFilter();

    if (index < 0) {
      this.props.parent.filterLocaleBySchoolAndUserId(this.state.mySchoolId, null);
    }
    else {
      let userId = this.state.userList[index]['id'];
      this.props.parent.filterLocaleBySchoolAndUserId(this.state.mySchoolId, userId);
    }
  }

  localeSortChanged(e) {
    let sortField = "id";
    let sortOrder = "DESC";
    switch (e.target.value) {
      case 0:
        sortField = "date_created";
        sortOrder = "DESC";
        break;
      case 1:
        sortField = "date_created";
        sortOrder = "ASC";
        break;
      case 2:
        sortField = "date_update";
        sortOrder = "DESC";
        break;
      case 3:
        sortField = "date_update";
        sortOrder = "ASC";
        break;
      case 4:
        sortField = "name";
        sortOrder = "ASC";
        break;
      case 5:
        sortField = "download_count";
        sortOrder = "DESC";
        break;
      case 6:
        sortField = "download_count";
        sortOrder = "ASC";
        break;
      default:
        break;
    }
    this.setState({
      localeSort: e.target.value,
      localeSortField: sortField,
      localeSortOrder: sortOrder,
    })
    this.state.localeSort = e.target.value;
    this.state.localeSortField = sortField;
    this.state.localeSortOrder = sortOrder;

    this.refreshLocale();
  }

  onKLAChanged(e) {
    this.setState({
      filterKLA: e.target.value,
    });
    this.state.filterKLA = e.target.value;
    this.props.parent.filterLocaleByKLA(e.target.value);
  }

  onSchoolSelected(school) {
    this.props.parent.changePage(0, false);
    if (school != null) {
      this.props.parent.setState({ filterSchoolID: school.value });
      this.props.parent.state.filterSchoolID = school.value;
    }
    else {
      this.props.parent.setState({ filterSchoolID: null });
      this.props.parent.state.filterSchoolID = null;
    }

    this.refreshLocale();
  }

  render() {
    return (
      <div ref="div" style={{padding:"10px 0 10px 10px", backgroundColor:grey[300]}}>
        <Button
          color="secondary"
          variant="contained"
          className="margin-sm"
          onClick={this.createLocale}
        >
          <Icon className="buttonIconLeft">add</Icon>
          {Localization.strings.NEW_VITALS}
        </Button>
        <Button
          color="primary"
          variant="contained"
          className="margin-sm"
          onClick={this.refreshLocale}
        >
          <Icon className="buttonIconLeft">refresh</Icon>
          {Localization.strings.REFRESH}
        </Button>

        {/*<div style={{display:'inline-block', verticalAlign:'middle', padding:'0 10px 0 10px'}}>
          <div style={{textAlign:'center'}}>
            {Helper.getFileSizeStr(this.state.fileSize) + " / 20.0 GB"}
          </div>
          <LinearProgress
            style={{width:'150px', margin:'auto'}}
            variant="determinate"
            value={this.state.fileSizePercentage}
          />
        </div>*/}
        <If condition={this.props.root.isAdminUser()}>
          <Then>
            <div style={styles.localeFilter}>
              <FormControl>
                <InputLabel style={{width:"65px",display:"Inline-block"}}>QA State</InputLabel>
                <Select
                  value={this.props.parent.state.qaState}
                  onChange={this.props.parent.onQAStateChanged}
                >
                  <MenuItem value={-1}>Any</MenuItem>
                  <MenuItem value={0}>Unchecked</MenuItem>
                  <MenuItem value={1}>Checked</MenuItem>
                  <MenuItem value={2}>Minor</MenuItem>
                  <MenuItem value={3}>Major</MenuItem>
                </Select>
              </FormControl>
            </div>
          </Then>
        </If>

        <If condition={this.props.root.getOriginalUserRole() >= 1}>
          <Then>
            {/*
            <Button
              color="primary"
              onClick={this.props.parent.onViewAngleClicked}
            >
              <Icon className="buttonIconLeft">{this.props.parent.state.isViewPublic? "visibility_off" : "visibility"}</Icon>
              {this.props.parent.state.isViewPublic? Localization.strings.VIEW_PRIVATE_VITALS : Localization.strings.VIEW_PUBLIC_VITALS}
            </Button>
            */}
            <div style={styles.localeFilter}>
              <FormControl>
                <InputLabel>{Localization.strings.SCHOOL}</InputLabel>
                <Select
                  value={this.props.parent.state.isViewPublic? 1 : 0}
                  onChange={this.props.parent.onViewAngleChanged}
                >
                  <MenuItem value={0}>{Localization.strings.MY_SCHOOL}</MenuItem>
                  <MenuItem value={1}>{Localization.strings.ALL_SCHOOLS}</MenuItem>
                </Select>
              </FormControl>
            </div>
          </Then>
        </If>

        <If condition={this.props.parent.state.isViewPublic && this.props.root.getOriginalUserRole() >= 1}>
          <Then>
            <div style={styles.localeFilter}>
              <SchoolList parent={this} root={this.props.root} ref="schoolList"
                schoolName={this.props.root.getMyUserData()['school_name']}
                onSchoolSelected={this.onSchoolSelected}
              />
            </div>
          </Then>
        </If>

        {
          // Normal User / Super User / Admin
        }
        <If condition={!this.props.parent.state.isViewPublic && this.props.root.getSameSchoolView() == 1}>
          <Then>
            <div style={styles.localeFilter}>
              <UserList parent={this} root={this.props.root}
                userOption={this.state.userOption}
                userList={this.state.userList}
              />
            </div>
          </Then>
        </If>

        <div style={styles.localeFilter}>
          <FormControl>
            <InputLabel>{Localization.strings.SORT_BY}</InputLabel>
              <Select
                value={this.state.localeSort}
                onChange={this.localeSortChanged}
              >
                <MenuItem value={0}>{Localization.strings.SORT_CREATE_DATE_DESC}</MenuItem>
                <MenuItem value={1}>{Localization.strings.SORT_CREATE_DATE_ASC}</MenuItem>
                <MenuItem value={2}>{Localization.strings.SORT_MODIFY_DATE_DESC}</MenuItem>
                <MenuItem value={3}>{Localization.strings.SORT_MODIFY_DATE_ASC}</MenuItem>
                <MenuItem value={4}>{Localization.strings.SORT_NAME_ASC}</MenuItem>
                <MenuItem value={5}>{Localization.strings.SORT_DOWNLOAD_COUNT_DESC}</MenuItem>
                <MenuItem value={6}>{Localization.strings.SORT_DOWNLOAD_COUNT_ASC}</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div style={styles.localeFilter}>
          <KLAList parent={this} root={this.props.root} ref="klaList"
            kla={this.state.filterKLA}
            hasLabel={true}
          />
        </div>

        <div style={styles.localeFilter}>
          <TextField
            value={this.state.searchText}
            onChange={this.searchTextChanged}
            label={Localization.strings.SEARCH}
            placeholder={Localization.strings.LOCALE_SEARCH_TEXT_PLACEHOLDER}
            InputLabelProps={{ shrink: true }}
            onKeyPress={this.handleSearchEnterPressed}
          />
        </div>
        <Tooltip title={Localization.strings.SEARCH}>
          <IconButton
            onClick={this.handleSearchClicked}
          >
            <Icon>search</Icon>
          </IconButton>
        </Tooltip>
        <Tooltip title={Localization.strings.CLEAR}>
          <IconButton
            onClick={this.handleClearClicked}
          >
            <Icon>clear</Icon>
          </IconButton>
        </Tooltip>
      </div>
    )
  }
}

export default LocaleViewerBar;
